<template>
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <router-link class="navbar-brand" :to="{ name: 'top' }">DEVEREACH</router-link>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNavDropdown">
            <ul class="navbar-nav">
                <li class="nav-item">
                    <router-link v-if="isAdmin" class="nav-link" :to="{ name: 'csvUpload' }" exact-active-class="current">csvアップロード<span class="sr-only">(current)</span></router-link>
                </li>
                <li class="nav-item">
                    <router-link v-if="isLoggedIn" class="nav-link" :to="{ name: 'favorite-list' }" exact-active-class="current">お気に入り物件<span class="sr-only">(current)</span></router-link>
                </li>
                <li class="nav-item">
                    <router-link v-if="isLoggedIn" class="nav-link" :to="{ name: 'mypage' }" exact-active-class="current">マイページ<span class="sr-only">(current)</span></router-link>
                </li>
                <li class="nav-item menu-logout-inner" v-if="isLoggedIn">
                    <a class="nav-link" @click="logout()" exact-active-class="current">ログアウト<span class="sr-only">(current)</span></a>
                </li>
                <li class="nav-item menu-logout-inner" v-else>
                    <router-link class="nav-link" :to="{ name: 'login' }" exact-active-class="current">ログイン<span class="sr-only">(current)</span></router-link>
                </li>
            </ul>
        </div>
        <el-button v-if="isLoggedIn" @click="logout" class="menu-logout-outer">ログアウト</el-button>
        <el-button v-else @click="login" class="menu-logout-outer">ログイン</el-button>
    </nav>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
    computed: {
        ...mapGetters({
            apiStatus: 'auth/getApiStatus'
        }),
        ...mapState({
            isLoggedIn: state => state.auth.isLoggedIn
        }),
        isAdmin() {
            return this.$store.getters['auth/getRole'] === 'admin'
        }
    },
    methods: {
        async logout() {
            await this.$store.dispatch('auth/logout')

            if (this.apiStatus) {
                this.$message({
                    message: 'ログアウトしました',
                    type: 'success'
                })

                this.$router.push({ name: 'login' })
            }
        },
        login() {
            this.$router.push({ name: 'login' })
        }
    }
}
</script>

<style scoped>
.current {
    border-bottom: 3px solid grey;
    margin: 0 auto;
    max-width: 135px;;
}

.menu-logout-outer {
    display: block;
}

.menu-logout-inner {
    display: none;
}

@media screen and (max-width: 991px){
    .menu-logout-outer {
        display: none;
    }

    .menu-logout-inner {
        display: block;
    }
}
</style>